export function hexToRGB(hex: string): { r: number; g: number; b: number } {
	const hexColor = hex.replace('#', '');

	return {
		r: parseInt(hexColor.substr(0, 2), 16),
		g: parseInt(hexColor.substr(2, 2), 16),
		b: parseInt(hexColor.substr(4, 2), 16),
	};
}
